module.exports = __webpack_public_path__ + "static/media/facebookColor.1e3de960.svg";